import { css, styled } from 'app/pages/request-single-page/components-v4/theme';

export const Filmstrip = styled.div`
  display: flex;
  gap: 6px;
  padding: 10px 16px;
  padding-bottom: max(10px, env(safe-area-inset-bottom));
  overflow-x: auto;
  flex-shrink: 0;
  max-width: 80dvw;
  scroll-snap-type: x mandatory;
  -webkit-overflow-scrolling: touch;
  scrollbar-width: none;

  &::-webkit-scrollbar {
    display: none;
  }
`;

export const FilmstripThumb = styled.button<{ $active: boolean }>`
  ${({ theme, $active }) => css`
    padding: 0;
    flex-shrink: 0;
    width: ${$active ? '114px' : '64px'};
    height: 64px;
    border-radius: ${theme.radiuses.xs};
    overflow: hidden;
    outline-offset: 0;
    outline-width: ${$active ? '2px' : '0px'};
    outline-style: solid;
    outline-color: ${theme.colors.primary[600]};
    border: none;
    cursor: pointer;
    scroll-snap-align: center;
    transition-duration: 200ms;

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      display: block;
      pointer-events: none;
    }
  `}
`;
